import React from 'react';

function Banner() {
  return (
    <section className="banner__area banner-height d-flex align-items-center p-relative">
      <div className="banner-shape d-none d-lg-block">
        {/* <img class="banner__shape-two" src="assets/imgs/shape/tower-shape-small.png" alt="image not found"> */}
      </div>
      <div className="swiper banner__active overflow-visible">
        <div className="swiper-wrapper">
          <div className="swiper-slide banner_more_item">
            <div className="container">
              <div className="row align-items-center gy-5">
                <div className="col-xl-7 col-lg-7">
                  <div className="banner__content p-relative">
                    <h1 className="banner__title large">
                      Hi,{' '}
                      <span className="banner__shape-hand">
                        <img src="assets/imgs/shape/hand-shape.png" alt="hand-shape" />
                      </span>{' '}
                      I’m <span className="bd-text-primary">Saravana Perumal</span>
                      <br /> Web Developer
                    </h1>
                    <p>
                      As a web developer with 3 years of experience, proficient in PHP, Laravel,
                      MySQL, ReactJS, and Adobe Photoshop, I create dynamic, user-friendly web
                      solutions.
                    </p>
                  </div>
                  <div className="banner__btn">
                    <a className="bd-btn is-btn-anim" target="_blank" href="assets/pdf/SaravanaPerumal_Resume.pdf">
                      <span className="bd-btn-inner">
                        <span className="bd-btn-normal">Download CV</span>
                        <span className="bd-btn-hover">Download CV</span>
                      </span>
                    </a>
                  </div>
                </div>
                <div className="col-xl-5 col-lg-5">
                  <div className="banner__thumb-wrapper">
                    <div className="banner__thumb">
                      <img src="assets/imgs/banner/banner-01.png" alt="banner" />
                    </div>
                    <div className="theme__social banner-social">
                      <a href="https://www.linkedin.com/in/saravana-perumal-686b7b179/" target="_blank">
                        <i className="fa-brands fa-linkedin"></i>
                      </a>
                      <a href="https://wa.me/+918300923800" target="_blank">
                        <i className="fa-brands fa-whatsapp"></i>
                      </a>
                      <a href="mailto:saravanaperumal768@gmail.com" target="_blank">
                        <i className="fas fa-envelope"></i>
                      </a>
                      <a href="https://github.com/saravanaperumal768" target="_blank">
                        <i className="fab fa-github"></i>
                      </a>
                    </div>
                  </div>

                  <div class="row text-center display_mob">
                                        <div class="footer__top">
                                          
                                            <div class="footer__content">
                                                <div class="theme__social">
                                                    <a href="https://www.linkedin.com/in/saravana-perumal-686b7b179/;" target="_blank"><i class="fa-brands fa-linkedin"></i>
                                                       
                                                    </a>
                                                    <a href="https://wa.me/+918300923800" target="_blank"><i class="fa-brands fa-whatsapp"></i>
                                                       
                                                    </a>
                                                    <a href="mailto:saravanaperumal768@gmail.com" target="_blank"><i class="fas fa-envelope"></i>
        
                                                        
                                                    </a>
        
                                                    <a href="https://github.com/saravanaperumal768" target="_blank"><i class="fab fa-github"></i>
        
                                                        
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
